import React from "react";
import { useLocation, useNavigate, useParams, NavLink } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const encoded_zoho_lead_id1 = location.state?.encoded_zoho_lead_id || null;
  const encoded_interview_link_send_count2 =
    location.state?.encoded_interview_link_send_count || null;


  const styles = {
    sectionstyle: {
      marginTop: "10px",
    },
    privacyPara: {
      marginTop: "6px",
    },
  };

 const gotoBack = () => {
  if (encoded_zoho_lead_id1 && encoded_interview_link_send_count2) {
    navigate("/terms-and-conditions", {
      state: {
        encoded_zoho_lead_id: encoded_zoho_lead_id1,
        encoded_interview_link_send_count: encoded_interview_link_send_count2,
      },
    });
  } else {
    navigate(-1); // fallback
  }
};



  return (
    <div>
      <div className="bg-white min-h-screen">
        <div className="relative isolate px-6 pt-0 lg:px-8">
          <div
            aria-hidden="true"
            className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          >
            <div
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
              className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-brand-muted to-brand-soft opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            />
          </div>
          <div className="mx-auto max-w-4xl py-8 sm:py-12 lg:py-12">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-gray-900 sm:text-3xl leading-tight">
                WEBSITE TERMS OF USE AND PRIVACY NOTICE
              </h1>
              <p className="text-lg text-gray-500">
                Paris Business Academy | Version 1.0 | Effective date: 2 October 2026
              </p>
            </div>

            <div className="space-y-8 text-gray-700">
              <section style={styles.sectionstyle}>
                <h3 className="text-xl font-bold text-gray-900">Part A – Website Terms of Use</h3>
                <p className="text-lg font-semibold text-brand termsheading">
                  1. Who we are and acceptance of these terms
                </p>
                <p>
                  This website, https://www.paris-business-academy.com (the “Website”), is operated by Paris Business Academy,
                  a higher education provider focused on digital-first student recruitment and admissions.
                  (“Paris Business Academy”, “we”, “us” or “our”).
                </p>
                <p>
                  By accessing or using the Website, you agree to these Terms of Use and to the applicable laws and
                  regulations. If you do not agree, please do not use the Website.
                  </p>
              </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand termsheading">
                  2. Intellectual property and limited licence
                </p>
                <p>
                  The content of the Website (including texts, documents, graphics, logos, course descriptions and other
                  materials) is protected by copyright, trademark and other intellectual property laws and belongs to
                  Paris Business Academy or its licensors.
                </p>
                <p>
                  We grant you a limited, non-exclusive, non-transferable and revocable licence to view the Website and
                  to download or print one copy of its materials for your personal, non-commercial use. Under this licence
                  you may not:
                  </p>
                <br />
                <ol className="list-decimal pl-5">
                  <li>modify or copy the materials, except as permitted above;</li>
                  <li>
                    use the materials for any commercial purpose or for any public display;
                  </li>
                  <li>
                    attempt to decompile, reverse engineer or extract the source code of any software or material on the Website;
                  </li>
                  <li>
                    remove any copyright, trademark or other proprietary notices from the materials; or
                  </li>
                  <li>
                    transfer the materials to another person or “mirror” them on any other server.
                  </li>
                </ol>
                <br />
                <p>
                  We may terminate this licence at any time if you breach these Terms of Use. Upon termination, you
                  must delete or destroy any materials you have downloaded or printed, in electronic or paper form.
                </p>
              </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand">
                  3. Information provided “as is”
                </p>
                <p>
                  The materials on the Website are provided for general information purposes. To the maximum extent
                  permitted by law, they are provided “as is”, without warranties of any kind, whether express or implied,
                  including implied warranties of merchantability, fitness for a particular purpose or non-infringement. We
                  do not warrant the accuracy, completeness, reliability or currency of the materials or of any linked
                  website.
                </p>
                <p>
                  Information on programmes, fees, admission requirements and qualifications is indicative and may
                  change. The binding terms of any programme are set out in the enrolment contract and the Students
                  Handbook.
                </p>
              </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand">
                 4. Limitation of liability
                </p>
                <p>
                  To the maximum extent permitted by law, Paris Business Academy and its suppliers shall not be liable for any indirect or
                  consequential damages, including loss of data, loss of profit or business interruption, arising from the
                  use of, or inability to use, the Website, even if we have been informed of the possibility of such damage.
                  Nothing in these Terms of Use excludes or limits our liability for wilful misconduct, gross negligence,
                  death or personal injury, or any other liability that cannot be excluded or limited under applicable law.
                  Nor do these Terms affect any mandatory rights you may have as a consumer under France law.
                </p>
              </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand">
                  5. Changes and errors
                </p>
                <p>
                  The Website may contain technical, typographical or photographic errors. We may amend the
                  materials, and these Terms of Use, at any time without prior notice, but we are under no obligation to
                  update the materials. The version published on the Website with the latest effective date applies.
                </p>
              </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand">
                  6. Links to other websites
                </p>
                <p>
                  The Website may contain links to third-party websites. We have not reviewed all linked websites and
                  are not responsible for their content. The inclusion of a link does not imply endorsement by Paris Business Academy. You
                  access linked websites at your own risk.
                </p>
              </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand">
                  7. Governing law and jurisdiction
                </p>
                <p>
                  These Terms of Use are governed by France law, without regard to its conflict-of-law rules. Subject to
                  any mandatory consumer protection rules that grant you the right to bring proceedings in the courts of
                  your place of residence, the courts of France have jurisdiction over any dispute relating to the Website.
                </p>
              </section>
              <section style={styles.sectionstyle}>
                <h3 className="text-xl font-bold text-gray-900">Part B – Privacy Notice for Website Visitors and Interview Applicants</h3>
                <p className="text-lg font-semibold text-brand">
                  1. Data controller
                </p>
                <p style={styles.privacyPara}>
                  The data controller is Paris Business Academy. Contact for all privacy
                  matters: info@paris-business-academy.com.
                </p>
                </section>
              <section style={styles.sectionstyle}>
                <p className="text-lg font-semibold text-brand">
                   2. Our commitments
                 </p>
                 <p>
                   We process personal data in accordance with Regulation 2016/679 (GDPR) and applicable France law. In particular, we:
                 </p>
                 <ol className="list-decimal pl-5">
                  <li>process personal data lawfully, fairly and transparently;</li>
                  <li>
                    collect personal data only for specified, explicit and legitimate purposes, and do not use it in a way that is incompatible with those purposes;
                  </li>
                  <li>
                    collect only data that is adequate, relevant and limited to what is necessary;
                  </li>
                  <li>
                    keep data accurate and up to date, and correct or delete inaccurate data without undue delay;
                  </li>
                  <li>
                    keep personal data only for as long as necessary for the purposes for which it is processed;
                  </li>
                  <li>
                    protect personal data with appropriate technical and organisational measures against loss, theft,
                    and unauthorised access, disclosure, copying, use or alteration; and
                  </li>
                  <li>
                    make this notice and our related policies readily available to you.
                  </li>
                </ol>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                  3. Data we collect and why
                 </p>
                 <p>
                   When you contact us, request information, apply or take part in an admissions interview, we may process:
                 </p>
                 <ol className="list-decimal pl-5">
                  <li>identity and contact data (name, email address, telephone number, nationality, date of birth);</li>
                  <li>
                    application data and supporting documents, including a copy of the photo-and-data page of your passport or identity card;
                  </li>
                  <li>
                    interview data, including notes and any recording of the interview conducted via our internal platform; and
                  </li>
                  <li>
                    technical data (such as IP address, browser and device information, and log data) and cookie data as described in our Cookie Policy, available from the Website homepage.
                  </li>
                  
                </ol>
                <p>
                   We use this data to respond to your enquiries, assess your application and eligibility, conduct and
                  document the admissions interview, verify your identity, keep the Website secure and comply with legal
                  obligations.
                 </p>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   4. Legal bases
                 </p>
                 <ol className="list-decimal pl-5">
                   <li>
                     Steps taken at your request before entering into a contract, such as assessing your application
                     (Art. 6(1)(b) GDPR);
                   </li>
                   <li>
                     Our legitimate interests in selecting suitable candidates, keeping our systems secure, preventing
                     fraud and defending legal claims (Art. 6(1)(f) GDPR);
                   </li>
                   <li>Compliance with legal and regulatory obligations (Art. 6(1)(c) GDPR);</li>
                   <li>
                     Your consent, where required by law (for example, for non-essential cookies or marketing
                     communications) (Art. 6(1)(a) GDPR).
                   </li>
                 </ol>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   5. Interview recording
                 </p>
                 <p>
                   Admissions interviews are conducted via our internal platform and may be recorded to document the
                   admissions decision and for quality and verification purposes. You will be informed before an interview
                   is recorded. Recordings and notes are accessible only to authorised administrative and management
                   personnel.
                 </p>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   6. Recipients
                 </p>
                 <p>
                   We share personal data only where necessary, with authorised internal personnel, IT and hosting
                   providers, professional advisors, awarding bodies and regulators, and public authorities where required
                   by law. Service providers act on our instructions under appropriate contractual safeguards. Personal
                   data is hosted within the France Economic Area and is not currently transferred outside it.
                 </p>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   7. Retention
                 </p>
                 <p>
                   We keep personal data only for as long as necessary for the purposes described above and in accordance
                   with the retention periods set out in our General Privacy Policy, including: communication and technical
                   records for generally 2–3 years; identity document copies for 5 years from collection; and records that
                   we are legally required to keep for the periods required by France law and by awarding bodies.
                 </p>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   8. Your rights
                 </p>
                 <p>
                   You have the right to access, rectify, erase, restrict the processing of, and obtain a portable copy of
                   your personal data, and to object to processing based on legitimate interests, including direct marketing.
                   Where processing is based on consent, you may withdraw it at any time. To exercise your rights, write to
                   info@paris-business-academy.com. We normally reply within one month.
                 </p>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   9. Complaints
                 </p>
                 <p>
                   You may lodge a complaint with the France Data Protection Authority (Garante per la protezione dei dati
                   personali) or with another competent supervisory authority.
                 </p>
               </section>
               <section style={styles.sectionstyle}>
                 <p className="text-lg font-semibold text-brand">
                   10. More information
                 </p>
                 <p>
                   For full details on how we process personal data of applicants and students, please read our General
                   Privacy Policy, Data Protection Policy and Cookie Policy.
                 </p>
               </section>
            </div>

            <div className="mt-10 flex items-center justify-center">
              <button
                onClick={gotoBack}
                className="rounded-md bg-brand px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
              >
                Go Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
